import * as React from 'react';
import { format } from 'date-fns';
import { cs } from 'date-fns/locale';
import { CalendarRegular } from '@fluentui/react-icons';
import { cn } from '../../utils/cn';
import { Calendar } from './Calendar';
import { Popover, PopoverContent, PopoverTrigger } from './Popover';

interface DatePickerProps {
  value?: Date | null;
  onChange?: (date: Date | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  dateFormat?: string;
}

function DatePicker({
  value,
  onChange,
  placeholder = 'Vyberte datum...',
  disabled = false,
  className,
  dateFormat = 'dd.MM.yyyy',
}: DatePickerProps) {
  const [open, setOpen] = React.useState(false);

  const handleSelect = (date: Date | undefined) => {
    onChange?.(date);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild disabled={disabled}>
        <button
          type="button"
          data-testid="date-picker-trigger-btn"
          className={cn(
            'flex h-10 w-full items-center justify-between border border-neutral-300 bg-white px-3 py-1 text-sm text-neutral-900 shadow-xs transition-all outline-hidden',
            'hover:border-neutral-400 hover:shadow-xs',
            'focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-hidden',
            'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-neutral-50',
            'aria-invalid:border-red-500 aria-invalid:ring-2 aria-invalid:ring-red-500/20',
            !value && 'text-neutral-400',
            className
          )}
          aria-invalid={undefined}
        >
          <span>{value ? format(value, dateFormat, { locale: cs }) : placeholder}</span>
          <CalendarRegular className="size-4 text-neutral-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={value ?? undefined}
          onSelect={handleSelect}
          locale={cs as any}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}

export { DatePicker };
export type { DatePickerProps };
